
  import { RegisterCustomerCommand } from '@/apiclient/apiclient_generated';
  import { NotificationService } from '@/services/notification-service';
  import { AccountModule, AccountStore } from '@/store/account';
  import Routes from '@/types/Routes';
  import { Options, Vue } from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';

  @Options({})
  export default class RegisterSmallLight extends Vue {
    @Prop() loggedInCallBack;

    private accountStore: AccountModule = AccountStore;

    registerForm = {} as RegisterCustomerCommand;

    subject = '';
    message = '';

    emailErrorMessage = '';
    isLoading = false;
    terms = false;

    validationResult = {
      isNameFilled: true,
      isSurnameFilled: true,
      isEmailFilled: true,
      isTermsFilled: true
    };

    created() {
      this.resetRegisterForm();
    }

    get isFormDisabled() {
      return this.isLoading;
    }

    validateForm() {
      this.validationResult.isNameFilled = !!this.registerForm.name;
      // this.validationResult.isSurnameFilled = !!this.registerForm.surname;
      this.validationResult.isEmailFilled = !!this.registerForm.email;
      this.validationResult.isTermsFilled = !!this.terms;

      return this.registerForm.name && this.registerForm.email && this.terms && !this.subject && !this.message;
    }

    login() {
      this.$router.push(Routes.registerSuccessfull.path);
    }

    getParamValue(paramName) {
      var url = window.location.search.substring(1); //get rid of "?" in querystring
      var qArray = url.split('&'); //get key-value pairs
      for (var i = 0; i < qArray.length; i++) {
        var pArr = qArray[i].split('='); //split key and value
        if (pArr[0] == paramName) return pArr[1]; //return value
      }
    }

    getSource() {
      var result = this.getParamValue('source') != null ? this.getParamValue('source').replaceAll('_', ' ') : 'RegisterForm';

      return result;
    }

    async register() {
      const validationResult = this.validateForm();
      if (!validationResult) {
        return;
      }

      this.isLoading = true;
      this.registerForm.surname = this.registerForm.name; //surname is a mandatory field, hence cloning the value
      const results = await this.accountStore.registerCustomer(this.registerForm);
      this.isLoading = false;

      this.processRegisterResults(results);
    }

    resetRegisterForm() {
      this.registerForm.company = '';
      this.registerForm.name = '';
      this.registerForm.surname = '';
      this.registerForm.email = '';
      this.registerForm.createdBy = this.getSource();
      // this.registerForm.password = '';
      this.terms = false;
    }

    processRegisterResults(data) {
      if (data.status === 400) {
        const errors = Object.values(data.response.errors);
        this.showErrors(Object.values(data.response.errors));
      } else if (!data.isSuccess) {
        this.showErrors(data.errors);
      } else {
        NotificationService.NotifySuccess('Customer has been successfully created.');
        this.resetRegisterForm();
        this.login();
      }
    }

    private showErrors(errorsArray) {
      errorsArray.forEach((error: string) => {
        NotificationService.NotifyError(error);
      });
    }
  }
